import type { ViewOnlyCopy } from '~publish/components/ViewOnlyCoachMarks'

export function getViewOnlyInsightsCopy({
  surface,
  canExport,
}: {
  surface: 'channel' | 'allChannels'
  canExport: boolean
}): ViewOnlyCopy {
  const settingsAsk =
    'To change the channel settings, ask an admin to update your permissions.'
  const exportAndSettingsAsk =
    'To export them or change the channel settings, ask an admin to update ' +
    'your permissions.'
  const ask = canExport ? settingsAsk : exportAndSettingsAsk

  return surface === 'channel'
    ? {
        title: 'You have view-only access to this channel',
        body: `You can see this channel's metrics. ${ask}`,
      }
    : {
        title: 'You have view-only access to your channels',
        body: `You can see the metrics for your channels. ${ask}`,
      }
}
